export default __webpack_public_path__ + "static/media/fracture.3b9b1561.svg";